import { render, staticRenderFns } from "./GroupMemberListComp.vue?vue&type=template&id=1326fff2&scoped=true"
import script from "./GroupMemberListComp.vue?vue&type=script&lang=js"
export * from "./GroupMemberListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1326fff2",
  null
  
)

export default component.exports